function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMorning = function SvgMorning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd",
      strokeWidth: 0.6,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.107 4.522a1.127 1.127 0 1 0-2.253 0v1.126a1.127 1.127 0 1 0 2.253 0z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.6,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.632 20.294H1.841a1.127 1.127 0 1 1 0-2.253h4.284a6.76 6.76 0 1 1 11.71 0h4.285a1.127 1.127 0 1 1 0 2.253zm3.348-10.14A4.506 4.506 0 0 0 9 18.042h5.961a4.506 4.506 0 0 0-2.98-7.886z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.6,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.947 8.288-.797.796a1.127 1.127 0 1 1-1.593-1.593l.797-.796a1.127 1.127 0 1 1 1.593 1.593zm-16.98 7.5a1.127 1.127 0 1 0 0-2.254H1.841a1.127 1.127 0 1 0 0 2.254zm20.28-1.127a1.127 1.127 0 0 1-1.127 1.127h-1.127a1.127 1.127 0 1 1 0-2.254h1.127a1.127 1.127 0 0 1 1.126 1.127zM4.81 9.084a1.127 1.127 0 0 0 1.593-1.593l-.797-.796a1.127 1.127 0 1 0-1.592 1.593l.797.796z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.6,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  })));
};
export default SvgMorning;